/**
 * Tiện ích đồng bộ bộ lọc trang admin với query string URL.
 *
 * Chuyển object filter (tìm kiếm, trạng thái, phân trang) thành URLSearchParams,
 * bỏ qua giá trị rỗng và page mặc định (= 1).
 */

/**
 * Xây dựng URLSearchParams từ bộ lọc admin để cập nhật thanh địa chỉ.
 *
 * @param {Object} filters - Key/value filter (search, status, page, ...).
 * @returns {URLSearchParams}
 */
export const buildSearchParamsFromAdminFilters = (filters) => {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (!value) {
      return;
    }

    if (key === 'page' && value === '1') {
      return;
    }

    params.set(key, String(value));
  });

  return params;
};
